export default __webpack_public_path__ + "media/DragAndDrop.22902c16.png";